// dashboard-agent-ia/src/utils/pinValidation.js

const FORBIDDEN_PINS = [
  '000000','111111','222222','333333','444444',
  '555555','666666','777777','888888','999999',
  '123456','654321','012345','987654','111222',
  '112233','121212','123123','456789','789456',
]

export const validatePin = (pin, phone = '', lang = 'fr') => {
  const msgs = {
    fr: {
      tooShort: 'Le PIN doit contenir 6 chiffres',
      tooSimple: 'PIN trop simple — choisissez un code plus sécurisé',
      sequential: 'Chiffres séquentiels (123456) non autorisés',
      phoneMatch: 'Votre PIN ne peut pas contenir une partie de votre numéro',
    },
    en: {
      tooShort: 'PIN must be 6 digits',
      tooSimple: 'PIN too simple — choose a more secure code',
      sequential: 'Sequential digits (123456) not allowed',
      phoneMatch: 'PIN cannot contain part of your phone number',
    },
    wo: {
      tooShort: 'PIN bi waroul am 6 nimeero',
      tooSimple: 'PIN bi dafa yomb — tann benn bu dëkk',
      sequential: 'Nimeero yi ci kanam dañu ko gën a bëgg',
      phoneMatch: 'PIN bi mën a am nimeero bi sa telefon',
    }
  }
  const m = msgs[lang] || msgs.fr
  if (pin.length !== 6) return m.tooShort
  if (FORBIDDEN_PINS.includes(pin)) return m.tooSimple
  let asc = true, desc = true
  for (let i = 0; i < pin.length - 1; i++) {
    if (parseInt(pin[i+1]) !== parseInt(pin[i]) + 1) asc = false
    if (parseInt(pin[i+1]) !== parseInt(pin[i]) - 1) desc = false
  }
  if (asc || desc) return m.sequential
  if (phone) {
    const cleanPhone = phone.replace(/\D/g, '').slice(-9)
    for (let i = 0; i <= cleanPhone.length - 4; i++) {
      if (pin.includes(cleanPhone.slice(i, i + 4))) return m.phoneMatch
    }
  }
  return null
}
